import type { SanityPageSection } from '#/lib/sanity/queries/sections';
import type { PageLayoutSharedProps } from '#/lib/types';
import { PageSections } from '#/components/PageSections';

type Props = PageLayoutSharedProps & {
  sections?: SanityPageSection[] | null;
};

export function Page({
  sections,
  initialData,
  isPreview,
  sanitySource,
}: Props) {
  return (
    <div className="min-h-screen">
      <PageSections
        sections={sections ?? []}
        initialData={initialData}
        isPreview={isPreview}
        sanitySource={sanitySource}
      />
    </div>
  );
}
